/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: How many?
 * 
 * == final
 * branches_num_t1
 *  
 * @param props 
 * @returns 
 */
export const averageNumberOfNewBranchesTotalCalculation = (props: any) => {
    const sum = props.finalSubmissions.reduce((acc: number, submission: any) => acc + submission.branches_num_t1 || 0, 0);

    return (sum / props.finalSubmissions.length).toFixed(2);
}